@for (product of products; track product; let i = $index) {
  <mat-card appearance="outlined">
    <h2>{{product.name}}</h2>
    <p><b>{{ 'CONFIGURATOR|Indeks:' | translate }} </b>{{product.code}}</p>
    <p><b>{{ 'CONFIGURATOR|Indeks rozszerzony:' | translate }} </b>{{product.codeExt}}</p>
    @if (this.curLang) {
      <p>
        <b>{{ 'CONFIGURATOR|Nazwa:' | translate }} </b>{{product.localizedNames[this.curLang] ? product.localizedNames[this.curLang] : ''}}
      </p>
    }
    @if (!hiddenPrice) {
      <p>
        <b>{{ 'CONFIGURATOR|Cena:' | translate }} </b>@if (product.listUnitPrice && product.listUnitPrice != '0' && product.listUnitPrice !== product.unitPrice) {
        <s>{{product.listUnitPrice}}</s>
        } {{ product.unitPrice | currency:currency:null:true:true }}
      </p>
    }
    <p><b>{{ 'CONFIGURATOR|Ilość:' | translate }} </b>{{product.quantity}}</p>
    @if (product.altProductionTime !== undefined) {
      <p><b>{{ 'CONFIGURATOR|Czas realizacji:' | translate }} </b>{{product.altProductionTime}}</p>
    }
    @if (product.configuration && product.configuration.length > 0) {
      <p><b>{{ 'CONFIGURATOR|Cechy:' | translate }} </b></p>
    }
    @if (product.configuration && product.configuration.length > 0) {
      <ul>
        @for (feature of product.configuration; track feature) {
          <li>
            {{feature.field}}: {{feature.value}}
          </li>
        }
      </ul>
    }
    <br>
    </mat-card>
  }
  @if (!loaded) {
    <mat-card appearance="outlined" class="loading-card">
      <div class="loading-content">
        <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
        <span class="loading-text">{{ 'CONFIGURATOR|Pobieranie atrybutów' | translate }}</span>
      </div>
    </mat-card>
  }
  @if (loaded && products.length === 0) {
    <mat-card appearance="outlined">
      <span class="loading-text">{{ 'CONFIGURATOR|Brak atrybutów' | translate }}</span>
    </mat-card>
  }
